import SearchSettingsForm from '@staticsnap/dashboard/components/search-settings/search-settings-form';

export default function SearchIndex() {
  return <SearchSettingsForm title="Search Settings" />;
}
